import { render, staticRenderFns } from "./features.vue?vue&type=template&id=5eb15631&scoped=true&lang=pug&"
import script from "./features.vue?vue&type=script&lang=js&"
export * from "./features.vue?vue&type=script&lang=js&"
import style0 from "./features.vue?vue&type=style&index=0&id=5eb15631&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb15631",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/mortgages?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231205171632%2Fcomponents%2Fproducts%2Fmortgages%2Ffeatures.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsMortgagesSavings: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/products/mortgages/savings.vue').default,WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/list-item.vue').default})
